export default function (to, from, savedPosition) {
    return new Promise(() => {
        if (to.hash) {
          window.scroll({ top: 0 })
        } else {
          document.querySelector('html').style.scrollBehavior = 'auto'
          window.scroll({ top: 0 })
          document.querySelector('html').style.scrollBehavior = 'smooth'
        }
      })
  }